import {Nullish} from 'shared/web';

import {EagGridState} from '../createEagGridStore';

/**
 * Composite selector for the drag/resize overlay state read by every
 * `GridCell`.  By merging 5 individual selectors into one that returns
 * a **reference-stable** object, we cut 5 × N×M subscriptions down to
 * 1 × N×M — a significant reduction for large grids.
 *
 * The selector caches the previous result and returns the same reference
 * when all five underlying fields are identical (`===`).  This is safe
 * because `useSyncExternalStore` compares with `Object.is`.
 */
export type CellOverlayState = {
  activeDragId: string | Nullish;
  overColumnId: string | Nullish;
  dropSide: 'left' | 'right' | Nullish;
  isResizing: boolean;
  resizingColumn: string | Nullish;
};

let cached: CellOverlayState = {
  activeDragId: null,
  overColumnId: null,
  dropSide: null,
  isResizing: false,
  resizingColumn: null,
};

export const selectCellOverlayState = (state: EagGridState): CellOverlayState => {
  if (
    state.activeDragId === cached.activeDragId &&
    state.overColumnId === cached.overColumnId &&
    state.dropSide === cached.dropSide &&
    state.isResizing === cached.isResizing &&
    state.resizingColumn === cached.resizingColumn
  ) {
    return cached;
  }

  cached = {
    activeDragId: state.activeDragId,
    overColumnId: state.overColumnId,
    dropSide: state.dropSide,
    isResizing: state.isResizing,
    resizingColumn: state.resizingColumn,
  };

  return cached;
};
